module.exports = __webpack_public_path__ + "img/ru.d9b7479a.png";